import { SchemaOf, object } from 'yup';
import { EmployeeModels } from 'Models';
import { selectSchema, stringSchema } from 'Common/Validation/BaseSchemas';

export const AddEmployeeSchema: SchemaOf<EmployeeModels.AddEmployee> = object({
	instituteId: selectSchema('Institute'),
	firstName: stringSchema('First Name'),
	lastName: stringSchema('Last Name'),
});
